import axios from 'axios';

// TODO Add handlers
export default axios.create({
  // Needed to save response cookies
  withCredentials: true,
});

/*
// TODO Implement

  # Install global version check interceptor. Will trigger a page reload if the JS version does not match the backend version
  $provide.factory "versionCheckInterceptor", [ '$timeout', 'trackJs', ( $timeout, trackJs ) ->
    response: ( response ) ->
      return unless response? && response.headers?
      appVersionFromBackend = response.headers('X-APP_VERSION')
      appVersionFromJS = "@@VERSION_GIT_HASH@@"
      if appVersionFromBackend? && appVersionFromBackend != appVersionFromJS
        log = "The application version from backend (#{appVersionFromBackend}) does not match the one injected in the JS (#{appVersionFromJS}). If this happens in loop, add --verbose to sails launch."
        console.log log
        $timeout ()->
          # Force a page reload without cache
          location.reload(true);
      return response
  ]
  $httpProvider.interceptors.push "versionCheckInterceptor"

mainApp.config [ '$provide', '$httpProvider',
  ($provide, $httpProvider) ->
    # Install global http handler for 403 - auth required
    $provide.factory "http403Interceptor", [ '$q', '$window', '$injector', 'trackJs', '$rootScope',
      ( $q, $window, $injector, trackJs, $rootScope ) ->
        responseError: ( response ) ->
          # Log this error
          trackJs.handleHttpResponse( response )

          # tell the mobile app http auth is required
          if response.status == 401 or response.status == 403
            $rootScope.postMobileMessage?( { type: 'http-auth-required', status: response.status } )

          if response.status == 401
            $window.location = '/signin'
            return $q.reject( response )

          else if response.status == 403
            $__ = $injector.get( '$__' )
            bootbox.alert $__( "You are not authorized to access this." ), () ->
              $window.location = '/'

            # Return response anyway else we have an unhandled Promise error message
            return response

          else if response.status == 404
            $window.location = '/'

            # Return response anyway else we have an unhandled Promise error message
            return response

          $q.reject response
    ]
    $httpProvider.interceptors.push "http403Interceptor"
]

 */
